import { Box, keyframes } from "@mui/material";
import { coverArt } from '../../../images/cover-art';

const Art = ({ src, alt, sx }) => {
  return (
    <Box
      sx={{
        ...sx,
        pointerEvents: "none",
        draggable: "false",
      }}
    >
      <img src={src} alt={alt} style={{ width: "100%" }} />
    </Box>
  );
};

const sway = ({ degree = "2deg", flipped = false }) => keyframes`
  0% {
    transform: ${flipped ? "scaleX(-1) " : ""}skew(${degree});
  }
  50% {
    transform: ${flipped ? "scaleX(-1) " : ""}skew(-${degree});
  }
    100% {
    transform: ${flipped ? "scaleX(-1) " : ""}skew(${degree});
  }
`;

const drift = ({ start, end, flipped = false }) => keyframes`
  0% {
    transform: ${flipped ? "scaleX(-1) " : ""}translate(${start});
  }
  100% {
    transform: ${flipped ? "scaleX(-1) " : ""}translate(${end});
  }
`;

export const Church = ({ sx }) => (
  <Art src={coverArt.church} alt="church" sx={sx} />
);
export const Cloud1 = ({ sx, start, end, speed = "20" }) => (
  <Art
    src={coverArt.cloud1}
    alt="cloud1"
    sx={{
      ...sx,
      animation: `${drift({ start, end })} ${speed}s linear infinite`,
      "&>*": { width: "100%", height: "100%" },
    }}
  />
);
export const Cloud2 = ({ sx, start, end, speed = "20" }) => (
  <Art
    src={coverArt.cloud2}
    alt="cloud2"
    sx={{
      ...sx,
      animation: `${drift({ start, end })} ${speed}s linear infinite`,
      "&>*": { width: "100%", height: "100%" },
    }}
  />
);
export const Grass = ({ sx }) => (
  <Art
    src={coverArt.grass}
    alt="tree"
    sx={{
      ...sx,
      animation: `${sway({ degree: "4deg" })} 6s ease-in-out infinite`,
      transformOrigin: "bottom",
      "&>*": { width: "100%", height: "100%" },
    }}
  />
);

export const Grass2 = ({ sx }) => (
  <Art
    src={coverArt.grass2}
    alt="grass2"
    sx={sx}
  />
);
export const Trees = ({ sx, flipped }) => (
  <Art
    src={coverArt.trees}
    alt="tree"
    sx={{
      ...sx,
      animation: `${sway({ degree: "1deg", flipped })} 8s ease-in-out infinite`,
      transformOrigin: "bottom",
      "&>*": { width: "100%", height: "100%" },
    }}
  />
);
export const Hill1 = ({ sx }) => (
  <Art src={coverArt.hills1} alt="hills1" sx={sx} />
);

export const Hill2 = ({ sx }) => (
  <Art src={coverArt.hills2} alt="hills2" sx={sx} />
);

export const Bush1 = ({ sx }) => (
  <Art
    src={coverArt.bush1}
    alt="bush1"
    sx={{
      ...sx,
      animation: `${sway({ degree: "0.2deg" })} 0.6s ease-in-out infinite`,
      transformOrigin: "bottom",
      "&>*": { width: "100%", height: "100%" },
    }}
  />
);

export const Bush2 = ({ sx }) => (
  <Art
    src={coverArt.bush2}
    alt="bush2"
    sx={{
      ...sx,
      animation: `${sway({ degree: "0.2deg" })} 0.4s ease-in-out infinite`,
      transformOrigin: "bottom",
      "&>*": { width: "100%", height: "100%" },
    }}
  />
);
export const Flowers = ({ sx }) => (
  <Art
    src={coverArt.flowers}
    alt="flowers"
    sx={{
      ...sx,
      animation: `${sway({ degree: "0.2deg" })} 0.4s ease-in-out infinite`,
      transformOrigin: "bottom",
      "&>*": { width: "100%", height: "100%" },
    }}
  />
);
